import { makeStyles, MenuItem, TableCell, TextField } from "@material-ui/core";
import React from "react";
import { SwissGermanLocale, SwissTimeZone } from "../../../../../data/constants";
import { ExamLocationViewModel } from "../../../../../model/ExamSignup/ModuleExamDetailsViewModel";

const useStyles = makeStyles({
  locationCell: {
    width: "300px",
  },
  dayCell: {
    width: "200px",
  },
});

type NormalSelectionTableCellsProps = {
  selectedLocationId?: string;
  selectedExamDayId?: string;
  onLocationChange: (locationId: string) => void;
  onDayChange: (examDayId: string) => void;
  availableLocations: ExamLocationViewModel[];
  disabled: boolean;
};

const NormalSelectionCells = ({
  selectedLocationId,
  selectedExamDayId,
  onLocationChange,
  onDayChange,
  availableLocations,
  disabled,
}: NormalSelectionTableCellsProps) => {
  const classes = useStyles();

  const locationOptions = availableLocations.map((location) => (
    <MenuItem key={location.locationId} value={location.locationId}>
      {location.name}
    </MenuItem>
  ));

  const selectedLocationDetails = availableLocations.find((l) => l.locationId === selectedLocationId);

  const examDayOptions = selectedLocationDetails?.examDays
    ? selectedLocationDetails?.examDays.map((examDay) => (
        <MenuItem key={examDay.examDayId} value={examDay.examDayId}>
          {new Date(examDay.date).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone })}
        </MenuItem>
      ))
    : [];

  return (
    <React.Fragment>
      <TableCell className={classes.locationCell}>
        <TextField
          select
          value={selectedLocationId ?? ""}
          onChange={(event) => onLocationChange(event.target.value as string)}
          fullWidth
          disabled={disabled}
        >
          {locationOptions}
        </TextField>
      </TableCell>
      <TableCell className={classes.dayCell}>
        <TextField
          select
          value={selectedExamDayId ?? ""}
          onChange={(event) => onDayChange(event.target.value as string)}
          disabled={!selectedLocationId || disabled}
          fullWidth
        >
          {examDayOptions}
        </TextField>
      </TableCell>
    </React.Fragment>
  );
};

export default NormalSelectionCells;
